import React, { useEffect, useState } from 'react';
import cls from 'classnames';
import Product from '../../../models/Product';
import styles from './stock_list.module.scss';
import FontAwesomeIcon from '../../core/fa_icon';

type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
  & { item: Product };

/**
 * Checkbox field for stock list.
 */
export const StockListItem: React.FC<Props> = ({ item, ...props }) => {
  const [checked, setChecked] = useState(props.checked);

  useEffect(() => setChecked(props.checked), [props.checked]);

  let sub: React.ReactNode = null;
  if (item.name.split(' ').includes('EBID')) {
    sub = "Ej BankID";
  }

  return (
    <label
      className={cls({
        [styles.item]: true,
        [styles.checked]: checked
      })}>
      <input
        {...props}
        type="checkbox"
        checked={checked}
        onChange={e => {
          setChecked(e.currentTarget.checked);
          props.onChange?.(e);
        }} />
      <span className={styles.label}>
        <FontAwesomeIcon name="check" className={styles.check} />
        {item.name}
      </span>
      {
        sub ? (<span className={styles.sub}>{sub}</span>) : null
      }
    </label>
  );
}